export default __webpack_public_path__ + "static/media/clientes.09f3a4b5.jpeg";